var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXlsxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5766_1614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9996 7.11719H14.7559V12.7047H23.9996V7.11719Z",
    fill: "#498E2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9996 12.7031H14.7559V18.2906H23.9996V12.7031Z",
    fill: "#498E2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7562 7.11719H5.53125V12.7047H14.7562V7.11719Z",
    fill: "#498E2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7563 18.2906V12.7031H5.55005V18.2906V19.0969V22.7719C5.55005 23.3719 6.03755 23.8594 6.63755 23.8594H22.8938C23.4938 23.8594 23.9813 23.3719 23.9813 22.7719V18.2906H14.7563Z",
    fill: "#185B37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8938 1.54688H14.7375V7.13437H24V2.63437C23.9813 2.03437 23.4938 1.54688 22.8938 1.54688Z",
    fill: "#33C481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7559 1.54688H6.65586C6.05586 1.54688 5.56836 2.03437 5.56836 2.63437V7.11562H14.7746V1.54688H14.7559Z",
    fill: "#498E2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1563 18.7969H1.2188C0.562549 18.7969 0.0187988 18.2531 0.0187988 17.5969V7.80938C0.0187988 7.15313 0.562549 6.60938 1.2188 6.60938H11.1563C11.8125 6.60938 12.3563 7.15313 12.3563 7.80938V17.5969C12.3563 18.2531 11.8313 18.7969 11.1563 18.7969Z",
    fill: "#498E2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.59395 16.1531L6.86269 14.8219C6.56269 14.2969 6.3752 13.9406 6.16895 13.5469H6.1502C5.98145 13.9406 5.8127 14.2969 5.53145 14.8219L4.8752 16.1531H3.4502L5.4752 12.7594L3.50645 9.42188H4.9502L5.68145 10.8094C5.90645 11.2219 6.0752 11.5594 6.24395 11.9344H6.28145C6.46895 11.5219 6.6002 11.2219 6.8252 10.8094L7.55645 9.42188H8.98145L6.9752 12.7031L9.05644 16.1531H7.59395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.5064 7.69531C12.5064 7.73281 12.5064 7.77031 12.5064 7.80781V17.5953C12.5064 18.2516 11.9627 18.7953 11.3064 18.7953H5.7002V19.8641H12.3002C12.9564 19.8641 13.5002 19.3203 13.5002 18.6641V8.87656C13.5189 8.27656 13.0689 7.77031 12.5064 7.69531Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5766_1614"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.703125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsxIcon);
export default __webpack_public_path__ + "static/media/xlsx-icon.8803be2128b0774b558e281c2aeba13d.svg";
export { ForwardRef as ReactComponent };